export function getMonthNumber(monthName) {
  const months = {
    GEN: "01",
    FEB: "02",
    MAR: "03",
    APR: "04",
    MAG: "05",
    GIU: "06",
    LUG: "07",
    AGO: "08",
    SET: "09",
    OTT: "10",
    NOV: "11",
    DIC: "12",
  };
  return months[String(monthName || "").toUpperCase()] || "01";
}

export function sortPeriodsChronologically(periods) {
  return (periods || []).slice(0).sort((a, b) => {
    const getComparableDate = (period) => {
      if (typeof period === "string" && period.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return period;
      }

      if (typeof period === "string" && period.includes(" - ")) {
        const start = period.split(" - ")[0];
        const parts = start.split(" ").filter(Boolean);
        const monthName = parts[0];
        const year = parts[1];
        const month = getMonthNumber(monthName);
        return `${year}-${String(month).padStart(2, "0")}-01`;
      }

      return String(period);
    };

    const dateA = getComparableDate(a);
    const dateB = getComparableDate(b);
    return dateA.localeCompare(dateB);
  });
}

export function calculatePeriodTotals(regionRows) {
  const rows = Array.isArray(regionRows) ? regionRows : [];
  const allPeriods = [...new Set(rows.flatMap((row) => Object.keys(row.periodi || {})))];
  const sortedPeriods = sortPeriodsChronologically(allPeriods);

  return sortedPeriods.map((periodo, index) => {
    const total = rows.reduce((acc, row) => {
      return acc + (row.periodi?.[periodo] || 0);
    }, 0);

    const fatturatoTotal = rows.reduce((acc, row) => {
      return acc + (row.fatturato?.[periodo] || 0);
    }, 0);

    let trend = "start";
    if (index > 0) {
      const previousPeriod = sortedPeriods[index - 1];
      const previousTotal = rows.reduce((acc, row) => {
        return acc + (row.periodi?.[previousPeriod] || 0);
      }, 0);

      if (previousTotal !== 0) {
        if (total > previousTotal) trend = "positive";
        else if (total < previousTotal) trend = "negative";
        else trend = "neutral";
      } else {
        trend = "neutral";
      }
    }

    let fatturatoTrend = "start";
    if (index > 0) {
      const previousPeriod = sortedPeriods[index - 1];
      const previousTotal = rows.reduce((acc, row) => {
        return acc + (row.fatturato?.[previousPeriod] || 0);
      }, 0);

      if (previousTotal !== 0) {
        if (fatturatoTotal > previousTotal) fatturatoTrend = "positive";
        else if (fatturatoTotal < previousTotal) fatturatoTrend = "negative";
        else fatturatoTrend = "neutral";
      } else {
        fatturatoTrend = "neutral";
      }
    }

    let displayName = periodo;
    if (typeof periodo === "string" && periodo.includes(" - ")) {
      displayName = periodo.replace(/20(\d{2})/g, "$1");
    }

    return { periodo: displayName, total, trend, fatturatoTotal, fatturatoTrend };
  });
}

export function formatPeriodLabel(periodo) {
  if (typeof periodo === "string" && periodo.includes(" - ")) return periodo;
  try {
    return new Intl.DateTimeFormat("it-IT", { month: "short", year: "2-digit" })
      .format(new Date(periodo))
      .toUpperCase();
  } catch (e) {
    return String(periodo);
  }
}
